export default "7b5ffb5c3a323b99.woff2"